module.exports = {
      id: "double-chevron-right-usage",
      viewBox: "0 0 24.124 20",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#double-chevron-right",
      toString: function () {
        return this.url;
      }
    }